module.exports = __webpack_public_path__ + "img/news10-3.fd751680.png";